/**
 * author andre.pitombeira
 */
/** @ngInject */
export default function userService($http, sessionService, RESOURCES, INSTANCE_IDS, API_V2_HEADER, USER_TYPES) {
  return {
    getUsers: getUsers,
    getUser: getUser,
    updateUser: updateUser,
    updatePassword: updatePassword,
    deleteUser: deleteUser,
    createUser: createUser,
    getAvailableUserRoles: getAvailableUserRoles,
  };

  function getUsers() {
    return $http.get(RESOURCES.USER);
  }

  function getAvailableUserRoles() {
    var isSuperAdmin = sessionService.hasRole([USER_TYPES.SUPER_ADMIN]),
      config = {
        params: {
          instanceIds: [INSTANCE_IDS.OC_API],
        },
        headers: API_V2_HEADER.headers,
      };

    return $http.get(RESOURCES.USER + '/roles', config).then(function(response) {
      if (response.data) {
        response.data = response.data
          .filter(function(role) {
            return (isSuperAdmin || role.name !== USER_TYPES.SUPER_ADMIN) && role.name !== USER_TYPES.DEAL_MANAGER;
          })
          .map(function(role) {
            return role.name;
          });
      }
      return response;
    });
  }

  function getUser(id) {
    return $http.get(RESOURCES.USER + '/' + id);
  }

  function updateUser(id, data) {
    return $http.put(RESOURCES.USER + '/' + id, data);
  }

  function updatePassword(id, data) {
    return $http.put(RESOURCES.USER + '/' + id + '/password', data);
  }

  function deleteUser(id) {
    return $http.delete(RESOURCES.USER + '/' + id);
  }

  function createUser(data) {
    return $http.post(RESOURCES.USER, data);
  }
}



// WEBPACK FOOTER //
// ./src/app/users/user.service.js